import { render, staticRenderFns } from "./add-paragraph.html?vue&type=template&id=c1758410&scoped=true&"
import script from "./add-paragraph.vue?vue&type=script&lang=js&"
export * from "./add-paragraph.vue?vue&type=script&lang=js&"
import style0 from "./add-paragraph.css?vue&type=style&index=0&id=c1758410&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1758410",
  null
  
)

export default component.exports